var _defs, _mask;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4356",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4360"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath4410"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path4408"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath4426"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path4424"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath4446"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path4444"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "custom"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#custom)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4362",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4364",
    transform: "translate(392,128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 64 H -64 V 0",
    style: {
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4366"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4368",
    transform: "translate(360,192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -32",
    style: {
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4370"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4372",
    transform: "translate(392,128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -32",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4374"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4376",
    transform: "translate(328,128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -32",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4378"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4380",
    transform: "translate(424,64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 64 H -128 V 0",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4382"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4384",
    transform: "translate(360,128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -64",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4386"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4388",
    transform: "translate(136,272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 320 V -208",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4390"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4392",
    transform: "translate(256,384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 16",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4394"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4396",
    transform: "translate(288,384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 16",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4398"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4400",
    transform: "translate(320,384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 16",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4402"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4406",
    clipPath: "url(#clipPath4410)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4412",
    transform: "translate(88,352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 416",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4414"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g4416",
    transform: "translate(200,320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -112",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4418"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4420"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4422",
    clipPath: "url(#clipPath4426)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4428",
    transform: "translate(504,320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -288",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4430"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g4432",
    transform: "translate(136,208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 64 l 64,-64 v -80",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4434"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4436",
    transform: "translate(264,144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -128",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4438"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4442",
    clipPath: "url(#clipPath4446)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4448",
    transform: "translate(168,64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -168",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4450"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4452",
    transform: "translate(0,288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 136 V -224",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4454"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4456",
    transform: "translate(0,128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 136",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4458"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4460",
    transform: "translate(232,64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-17.673 -14.327,-32 -32,-32 -17.673,0 -32,14.327 -32,32 0,17.673 14.327,32 32,32 C -14.327,32 0,17.673 0,0 Z",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4462"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4464",
    transform: "translate(192,64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 16",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4466"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4468",
    transform: "translate(32,96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 80",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4470"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4472",
    transform: "translate(152,120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 32",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4474"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4476",
    transform: "translate(504,200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -136 H -272",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4478"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4480",
    transform: "translate(88,288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 64 L 208,192 416,64 V -72",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4482"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4484",
    transform: "translate(136,240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 320",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4486"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.36def2f1c87cfb40afa0a6bd39a69239.svg";
export { ForwardRef as ReactComponent };